import request from '../../../helpers/request';

const changeClientPassportInfo = async (values) => {
  const response = await request.put(
    `/HousingStock/client/documents/passport`,
    values,
    `При изменении паспортных данных произошла ошибка`
  );

  return response;
};

export default changeClientPassportInfo;
